/**
 * Created by ObadaDarwish on 23/09/2018.
 */

import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AppComponent} from './app.component';
import {HuaweiEgyptComponent} from './events/events-templates/huawei-egypt/huawei-egypt.component';
import {EventsComponent} from './events/events.component';
import {HonorComponent} from './events/events-templates/honor/honor.component';
import {EmotionCupComponent} from './events/events-templates/emotion-cup/emotion-cup.component';
import {InsomniaEgyptComponent} from './events/events-templates/insomnia-egypt/insomnia-egypt.component';
import {CounterStrikeComponent} from './events/events-templates/insomnia-egypt/counter-strike/counter-strike.component';
import {DotaComponent} from './events/events-templates/insomnia-egypt/dota/dota.component';
import {LeagueOfLegendsComponent} from './events/events-templates/insomnia-egypt/league-of-legends/league-of-legends.component';
import {OverwatchComponent} from './events/events-templates/insomnia-egypt/overwatch/overwatch.component';
import {TekkenComponent} from './events/events-templates/insomnia-egypt/tekken/tekken.component';
import {HomeComponent} from './events/events-templates/insomnia-egypt/home/home.component';
import {FortniteComponent} from './events/events-templates/insomnia-egypt/fortnite/fortnite.component';
import {CallOfDutyComponent} from './events/events-templates/insomnia-egypt/call-of-duty/call-of-duty.component';
import {RainbowSixComponent} from './events/events-templates/insomnia-egypt/rainbow-six/rainbow-six.component';
import {InsominaTermsConditionsComponent} from './events/events-templates/insomnia-egypt/insomina-terms-conditions/insomina-terms-conditions.component';
import {FifaComponent} from './events/events-templates/insomnia-egypt/fifa/fifa.component';
import {BlackoutBattleRtxComponent} from "./events/events-templates/blackout-battle-rtx/blackout-battle-rtx.component";
import {CfcComponent} from './events/events-templates/cfc/cfc.component';
import {CfcStatsComponent} from "./events/events-templates/cfc/cfc-stats/cfc-stats.component";
import {CommunityComponent} from "./events/events-templates/community/community.component";
import {PortoComponent} from "./events/events-templates/porto/porto.component";
import {InsomniaEgypt19Component} from "./events/events-templates/insomnia-egypt19/insomnia-egypt19.component";
import {halloweenNights} from "./events/events-templates/halloween-nights/halloween-nights.component";
import {HalloweenTournamentsComponent} from "./events/events-templates/halloween-nights/halloween-tournaments/halloween-tournaments.component";
import {InsomniaTournamentsComponent} from "./events/events-templates/insomnia-egypt19/insomnia-tournaments/insomnia-tournaments.component";
import {WinterWonderComponent} from "./events/events-templates/winter-wonder/winter-wonder.component";
import {WinterWonderTournamentsComponent} from "./events/events-templates/winter-wonder/winter-wonder-tournaments/winter-wonder-tournaments.component";
import {DashboardComponent} from './dashboard/dashboard.component';
import {DashboardLoginComponent} from './dashboard-login/dashboard-login.component';
import {LoginGuard} from './guards/login.guard';
import {ChristmasComponent} from './events/events-templates/christmas/christmas.component';
import {AuthUserResolver} from './guards/auth-user-resolver.service';
import {ChristmasTournamentsComponent} from './events/events-templates/christmas/christmas-tournaments/christmas-tournaments.component';
import {ShawarmerComponent} from './events/events-templates/shawarmer/shawarmer.component';
import {ShawarmerTournmanetsComponent} from './events/events-templates/shawarmer/shawarmer-tournmanets/shawarmer-tournmanets.component';
import {ShawarmerCitiesComponent} from './events/events-templates/shawarmer/shawarmer-cities/shawarmer-cities.component';
import {FriendZoneComponent} from './events/events-templates/friend-zone/friend-zone.component';
import {FriendZoneTournamentsComponent} from './events/events-templates/friend-zone/friend-zone-tournaments/friend-zone-tournaments.component';
import { SpringBreakComponent } from './events/events-templates/spring-break/spring-break.component';
import { PubgLiteComponent } from './events/events-templates/spring-break/pubg-lite/pubg-lite.component';
import { CrossfireComponent } from './events/events-templates/spring-break/crossfire/crossfire.component';
import { RainbowSixSeigeComponent } from './events/events-templates/spring-break/rainbow-six-siege/rainbow-six-siege.component';
import { SpringHomeComponent } from './events/events-templates/spring-break/spring-home/spring-home.component';
import { PubgComponent } from './events/events-templates/spring-break/pubg/pubg.component';
import { Ramadan2020Component } from './events/events-templates/ramadan2020/ramadan2020.component';
import {RamadanHomeComponent} from './events/events-templates/ramadan2020/ramadan-home/ramadan-home.component';
import {Ramadan20PubgLiteComponent} from './events/events-templates/ramadan2020/ramadan20-pubg-lite/ramadan20-pubg-lite.component';
import {Ramadan20BrawlStarsComponent} from "./events/events-templates/ramadan2020/ramadan20-brawl-stars/ramadan20-brawl-stars.component";
import {Ramadan20CrossfireComponent} from "./events/events-templates/ramadan2020/ramadan20-crossfire/ramadan20-crossfire.component";
import {Ramadan20FortniteComponent} from "./events/events-templates/ramadan2020/ramadan20-fortnite/ramadan20-fortnite.component";
import {Ramadan20ClashRoyaleComponent} from "./events/events-templates/ramadan2020/ramadan20-clash-royale/ramadan20-clash-royale.component";
import {Ramadan20PubgComponent} from "./events/events-templates/ramadan2020/ramadan20-pubg/ramadan20-pubg.component";
import {Ramadan20RainbowSixSiegeComponent} from "./events/events-templates/ramadan2020/ramadan20-rainbow-six-siege/ramadan20-rainbow-six-siege.component";
import {Ramadan20LeagueOfLegendsComponent} from "./events/events-templates/ramadan2020/ramadan20-league-of-legends/ramadan20-league-of-legends.component";
import {OrangeRamadanCupComponent} from "./events/events-templates/orange-ramadan-cup/orange-ramadan-cup.component";
import {OrangeRamadanTournamentsComponent} from "./events/events-templates/orange-ramadan-cup/orange-ramadan-tournaments/orange-ramadan-tournaments.component";
import {YallaAwcComponent} from "./events/events-templates/yalla-awc/yalla-awc.component";
import {SnickersECupComponent} from "./events/events-templates/snickers-e-cup/snickers-e-cup.component";
import {TournamentRulesComponent} from "./events/events-templates/snickers-e-cup/tournament-rules/tournament-rules.component";
import {ParticipantsComponent} from "./events/events-templates/snickers-e-cup/participants/participants.component";
import {HowToJoinComponent} from "./events/events-templates/snickers-e-cup/how-to-join/how-to-join.component";
import {BracketsComponent} from "./events/events-templates/snickers-e-cup/brackets/brackets.component";
import {GeneralInfoComponent} from "./events/events-templates/snickers-e-cup/general-info/general-info.component";
import {RenoCupComponent} from "./events/events-templates/reno-cup/reno-cup.component";
import {RenoCupTournamentsComponent} from "./events/events-templates/reno-cup/reno-cup-tournaments/reno-cup-tournaments.component";
import {RenoCupBracketsComponent} from "./events/events-templates/reno-cup/reno-cup-brackets/reno-cup-brackets.component";
import {RenoCupQualifiedComponent} from "./events/events-templates/reno-cup/reno-cup-qualified/reno-cup-qualified.component";
import {HighlightsComponent} from "./events/events-templates/reno-cup/highlights/highlights.component";
import {OppoEgypt2021Component} from "./events/events-templates/oppo-egypt2021/oppo-egypt2021.component";
import {OppoEgyptTournamentsComponent} from "./events/events-templates/oppo-egypt2021/oppo-egypt-tournaments/oppo-egypt-tournaments.component";
import {PrizesComponent} from "./events/events-templates/oppo-egypt2021/prizes/prizes.component";
import {RulesTermsComponent} from "./events/events-templates/oppo-egypt2021/rules-terms/rules-terms.component";
import {PlayerCardComponent} from "./events/events-templates/oppo-egypt2021/player-card/player-card.component";
import {OppoGulfTournamentsComponent} from "./events/events-templates/oppo-Gulf2021/oppo-gulf-tournaments/oppo-gulf-tournaments.component";
import {OppoGulf2021Component} from "./events/events-templates/oppo-Gulf2021/oppo-gulf2021.component";
import {QualifiedPlayerComponent} from "./events/events-templates/oppo-Gulf2021/qualified-player/qualified-player.component";
import {RulesTermsGulfComponent} from "./events/events-templates/oppo-Gulf2021/rules-terms-gulf/rules-terms-gulf.component";
import {PrizesGulfComponent} from "./events/events-templates/oppo-Gulf2021/prizes-gulf/prizes-gulf.component";
import {TecnoCupComponent} from "./events/events-templates/tecno-cup/tecno-cup.component";
import {TecnoTournamentsComponent} from "./events/events-templates/tecno-cup/tecno-tournaments/tecno-tournaments.component";
import {TecnoPlayerCardComponent} from "./events/events-templates/tecno-cup/player-card/player-card.component";
import {RulesTermsTecnoComponent} from "./events/events-templates/tecno-cup/rules-terms/rules-terms-tecno.component";
import {Ramdan2022Component} from "./events/events-templates/ramdan2022/ramdan2022.component";
import {Ramadan2022HomePageComponent} from "./events/events-templates/ramdan2022/ramadan2022-home-page/ramadan2022-home-page.component";
import {Ramadan2022TournamentComponent} from "./events/events-templates/ramdan2022/ramadan2022-tournament/ramadan2022-tournament.component";
import {Ramadan2022PlayerQualifiedComponent} from "./events/events-templates/ramdan2022/ramadan2022-player-qualified/ramadan2022-player-qualified.component";
import {TecnoTournamentsIraqcomponent} from './events/events-templates/tecno-cup-iraq/tecno-tournaments/tecno-tournaments.iraqcomponent';
import {TecnoCupIraqComponent} from './events/events-templates/tecno-cup-iraq/tecno-cup-iraq.component';
import {RulesTermsTecnoIraqComponent} from './events/events-templates/tecno-cup-iraq/rules-terms/rules-terms-tecno-iraq.component';
import {MainPageIraqComponent} from './events/events-templates/tecno-cup-iraq/main-page/main-page-iraq.component';
import {TecnoPlayerCardIraqComponent} from './events/events-templates/tecno-cup-iraq/player-card/player-card-iraq.component';
import {TecnoCupKsaComponent} from './events/events-templates/tecno-cup-ksa/tecno-cup-ksa.component';
import {HomePageKSAComponent} from './events/events-templates/tecno-cup-ksa/Home-page/Home-page-KSA.component';
import {TecnoTournamentsKSAComponent} from './events/events-templates/tecno-cup-ksa/tecno-tournaments/tecno-tournaments.KSA.component';
import {TecnoPlayerCardKSAComponent} from './events/events-templates/tecno-cup-ksa/player-card/player-card-KSA.component';
import {RulesTermsTecnoKSAComponent} from './events/events-templates/tecno-cup-ksa/rules-terms/rules-terms-tecno-KSA.component';
const routes: Routes = [
  {
    path: '', component: AppComponent, children: [
      {
        path: '', component: EventsComponent, children: [
          {path: '', redirectTo: 'ramadan-2022', pathMatch: 'full'},
          {path: 'honor', component: HonorComponent},
          {path: 'emotion-cup', component: EmotionCupComponent},
          {path: 'community', component: CommunityComponent},
          {
              path: 'insomnia-egypt', component: InsomniaEgyptComponent, children: [
              {path: '', redirectTo: 'home', pathMatch: 'full'},
              {path: 'home', component: HomeComponent},
              {path: 'fortnite', component: FortniteComponent},
              {path: 'call-off-duty', component: CallOfDutyComponent},
              {path: 'overwatch', component: OverwatchComponent},
              {path: 'league-of-legends', component: LeagueOfLegendsComponent},
              {path: 'dota', component: DotaComponent},
              {path: 'counter-strike', component: CounterStrikeComponent},
              {path: 'rainbow-six', component: RainbowSixComponent},
              {path: 'tekken', component: TekkenComponent},
              {path: 'fifa-19', component: FifaComponent},
              {path: 'terms-conditions', component: InsominaTermsConditionsComponent}
            ]
          },

        {
          path: 'orange-ramadan-cup', component: OrangeRamadanCupComponent, children: [
          {path: 'tournaments', component: OrangeRamadanTournamentsComponent }
        ]
        },
          {
          path: 'oppo-reno-cup-season-2', component: OppoEgypt2021Component, children: [
              {path: '', redirectTo: 'tournaments', pathMatch: 'full'},

              {path: 'tournaments', component: OppoEgyptTournamentsComponent },
              {path: 'qualified-player', component: PlayerCardComponent },
              {path: 'rules-terms', component: RulesTermsComponent },
              {path: 'prizes', component: PrizesComponent }
        ]
        },
          {
          path: 'ramadan-2022', component: Ramdan2022Component, children: [
              {path: '', redirectTo: 'home', pathMatch: 'full'},

              {path: 'home', component: Ramadan2022HomePageComponent },
              {path: 'tournaments', component: Ramadan2022TournamentComponent },
              {path: 'players', component: Ramadan2022PlayerQualifiedComponent },
        ]
        },
          {
          path: 'reno-6-pubg-mobile-cup-gulf', component: OppoGulf2021Component, children: [
              {path: '', redirectTo: 'tournaments', pathMatch: 'full'},
              {path: 'tournaments', component: OppoGulfTournamentsComponent },
              {path: 'qualified-player', component: QualifiedPlayerComponent },
              {path: 'rules-terms', component: RulesTermsGulfComponent },
              {path: 'prizes', component: PrizesGulfComponent }
        ]
        }, {
          path: 'tecno-pubg-mobile-cup', component: TecnoCupComponent, children: [
              {path: '', redirectTo: 'tournaments', pathMatch: 'full'},
              {path: 'tournaments', component: TecnoTournamentsComponent },
              {path: 'qualified-player', component: TecnoPlayerCardComponent },
              {path: 'rules-terms', component: RulesTermsTecnoComponent },
        ]
        },
          {
            path: 'tecno-pubg-mobile-cup-2-saudia',
            redirectTo: 'tecno-pubg-mobile-cup-2-saudi-arabia', pathMatch: 'full',
          },
          {
          path: 'tecno-pubg-mobile-cup-2-saudi-arabia', component: TecnoCupKsaComponent, children: [
              {path: '', redirectTo: 'home', pathMatch: 'full'},
              {path: 'home', component: HomePageKSAComponent },
              {path: 'tournaments', component: TecnoTournamentsKSAComponent },
              {path: 'qualified-player', component: TecnoPlayerCardKSAComponent },
              {path: 'rules-terms', component: RulesTermsTecnoKSAComponent },
        ]
        },
          {
            path: 'tecno-pubg-mobile-cup-2-iraq', component: TecnoCupIraqComponent, children: [
              {path: '', redirectTo: 'home', pathMatch: 'full'},
              {path: 'home', component: MainPageIraqComponent },
              {path: 'tournaments', component: TecnoTournamentsIraqcomponent },
              {path: 'qualified-player', component: TecnoPlayerCardIraqComponent },
              {path: 'rules-terms', component: RulesTermsTecnoIraqComponent },
        ]
        },
          {
               path: 'reno-cup', component: RenoCupComponent, children: [
              {path: '', redirectTo: 'tournaments', pathMatch: 'full'},
              {path: 'tournaments', component: RenoCupTournamentsComponent },
              {path: 'brackets', component: RenoCupBracketsComponent },
              {path: 'qualified-players', component: RenoCupQualifiedComponent },
              {path: 'highlights', component: HighlightsComponent }
            ]
          },
        {
          path: 'ramadan2020', component: Ramadan2020Component, children: [
          {path: '', redirectTo: 'home', pathMatch: 'full'},
          {path: 'home', component: RamadanHomeComponent},
          {path: 'pubg-lite', component: Ramadan20PubgLiteComponent},
          {path: 'brawl-stars', component: Ramadan20BrawlStarsComponent},
          {path: 'crossfire', component: Ramadan20CrossfireComponent},
          {path: 'fortnite', component: Ramadan20FortniteComponent},
          {path: 'clash-royale', component: Ramadan20ClashRoyaleComponent},
          {path: 'pubg', component: Ramadan20PubgComponent},
          {path: 'rainbow-six-siege', component: Ramadan20RainbowSixSiegeComponent},
          {path: 'league-of-legends', component: Ramadan20LeagueOfLegendsComponent},
        ]
        },
          {
            path: 'snickers-e-cup', component: SnickersECupComponent, children: [
              {path: '', redirectTo: 'home', pathMatch: 'full'},
              {path: 'home', component: GeneralInfoComponent},
              {path: 'brackets', component: BracketsComponent},
              {path: 'how-to-join', component: HowToJoinComponent},
              {path: 'participants', component: ParticipantsComponent},
              {path: 'tournament-rules', component: TournamentRulesComponent},
            ]
          },
          {path: 'yalla-arabian-cup', component: YallaAwcComponent},
          {
            path: 'spring-break', component: SpringBreakComponent, children: [
              {path: '', redirectTo: 'home', pathMatch: 'full'},
              {path: 'home', component: SpringHomeComponent},
              {path: 'rainbow-six-siege', component: RainbowSixSeigeComponent},
            {path: 'pubg', component: PubgComponent},
            {path: 'pubg-lite', component: PubgLiteComponent},
              {path: 'crossfire', component: CrossfireComponent},
              {path: 'terms-conditions', component: InsominaTermsConditionsComponent}
            ]
          },
          {path: 'huawei-egypt', component: HuaweiEgyptComponent},
          {path: 'blackout-battle-rtx', component: BlackoutBattleRtxComponent},
          {path: 'cfc', component: CfcComponent},
          {path: 'cfc/stats', component: CfcStatsComponent},
          {path: 'Gulfportomarina', component: PortoComponent},
          {
            path: 'insomnia-egypt19', component: InsomniaEgypt19Component, children: [
              {path: ':code', component: InsomniaTournamentsComponent}
            ]
          },
          {
            path: 'halloween-nights', component: halloweenNights, children: [
              {path: ':code', component: HalloweenTournamentsComponent}
            ]
          },
          {
            path: 'winter-wonder', component: WinterWonderComponent, children: [
              {path: ':code', component: WinterWonderTournamentsComponent}
            ]
          },
          {
            path: 'christmas', component: ChristmasComponent, children: [
              {path: ':code', component: ChristmasTournamentsComponent}
            ]
          },
          {
            path: 'friend-zone', component: FriendZoneComponent, children: [
              {path: ':code', component: FriendZoneTournamentsComponent}
            ]
          },
          {
            path: 'shawarmer', component: ShawarmerComponent, children: [
              {
                path: ':code', component: ShawarmerTournmanetsComponent
              }
            ]
          },
          {
            path: 'samsung-mobile-masters',
            loadChildren: () => import('app/events/events-templates/samsung-mobile-masters/samsung-mobile-masters.module').then(m => m.SamsungMobileMastersModule)

          },
        ]
      },
      {
        path: 'dashboard',
        canActivate: [LoginGuard],
        resolve: {authUser: AuthUserResolver},
        component: DashboardComponent
      },
      {path: 'login', component: DashboardLoginComponent}
    ]
  }

];


export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes , { scrollPositionRestoration: 'disabled' });
